interface RegisterProps {
    title: string;
    text: string;
    successTitle: string;
    successText: string;
}

export default RegisterProps;

export const B2C_CUSTOMER_TYPE = 'b2c';
export const B2B_CUSTOMER_TYPE = 'b2b';
export type CustomerType = 'b2c' | 'b2b';